module.exports = __webpack_public_path__ + "img/zhanli5.f9907b82.jpg";